import React, { FC } from 'react';

type Props = {
  data: { title: string; values: string[] };
};
const DisplayMetaDataCard: FC<Props> = ({ data }) => {
  return (
    <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
      <div className='w-[150px]'>
        <p className='text-[#858585] text-sm font-medium'>{data.title}</p>
      </div>
      <div className='flex gap-[12px] flex-wrap'>
        {data.values?.map((item: string, index) => (
          <div
            key={index}
            className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
            <p className='text-[#E60A2B] text-sm'>{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DisplayMetaDataCard;
